import {call, put, select, takeLatest} from "redux-saga/effects";
import {
  copyTestAction,
  copyTestActionDone, copyTestActionFail,
  copyTypeAction, copyTypeActionDone, copyTypeActionFail,
  deleteTypeAction,
  deleteTypeActionDone, deleteTypeActionFail,
  editTypeAction,
  editTypeActionDone,
  editTypeActionFail,
  getLibraryAction,
  getLibraryActionDone,
  getLibraryActionFail,
  getLibraryCurrentAction,
  getLibraryCurrentActionDone,
  getLibraryCurrentActionFail,
} from "./actions";
import {apiGetLibrary, apiGetLibraryCurrent} from "./api";
import {PayloadAction} from "@reduxjs/toolkit";
import {message} from "antd";
import {getOneLessonFlow} from "../plans/saga";


function* getLibraryActionFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetLibrary, payload);
    if (data.data) {
      yield put(getLibraryActionDone(data.data));
    }
  } catch (e) {
    yield put(getLibraryActionFail());
  }
}

function* getLibraryCurrentActionFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetLibraryCurrent, payload);
    if (data.data) {
      yield put(getLibraryCurrentActionDone(data.data));
    }
  } catch (e) {
    yield put(getLibraryCurrentActionFail());
  }
}

function* copyTypeFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    yield put(copyTypeActionDone(payload))
    message.success('Скопировалось успешно!')
  }
  if (isFail) {
    yield put(copyTypeActionFail(payload))
  }
}


function* editTypeFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    yield put(editTypeActionDone(payload))
    message.success('Отредактировано успешно!')
  }
  if (isFail) {
    yield put(editTypeActionFail(payload))
  }
}

function* deleteTypeFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    yield put(deleteTypeActionDone(payload))
    message.success('Удалено успешно!')
  }
  if (isFail) {
    yield put(deleteTypeActionFail(payload))
  }
}

function* copyTestActionFlow({payload}: PayloadAction<any>): any {
  const isDone = payload.success
  const isFail = payload.failed

  if (isDone) {
    yield put(copyTestActionDone(payload))
    // @ts-ignore
    yield call(getOneLessonFlow, {payload: {lesson_id: payload.data?.to_lesson_id}})
    message.success('Скопировалось успешно!')
  }
  if (isFail) {
    for(let i = 0; i < payload?.error?.response?.data?.length; i++){
      message.error(payload?.error?.response?.data?.[i]?.message)
    }
    yield put(copyTestActionFail(payload))
  }
}

export default function* profileSaga() {
  yield takeLatest(getLibraryAction, getLibraryActionFlow);
  yield takeLatest(getLibraryCurrentAction, getLibraryCurrentActionFlow);
  yield takeLatest(copyTypeAction, copyTypeFlow);
  yield takeLatest(editTypeAction, editTypeFlow);
  yield takeLatest(deleteTypeAction, deleteTypeFlow);
  yield takeLatest(copyTestAction, copyTestActionFlow);
}
